import { Synop } from './Synop'
import type { ObservationAemet as ServiceObservationAemet } from './api/ObservationAemet'
import DateService from '@services/DateService'

export class ObservationAemet {
  id: number
  fint: string
  prec: number
  pacutp: number
  pliqtp: number
  psolt: number
  vmax: number
  vv: number
  vmaxu: number
  vvu: number
  originWindDirection: number
  dvu: number
  dmax: number
  dmaxu: number
  stdvv: number
  stddv: number
  stdvvu: number
  stddvu: number
  hr: number
  inso: number
  pres: number
  presNmar: number
  ts: number
  tss20cm: number
  tss5cm: number
  ta: number | string
  tpr: number
  tamin: number
  tamax: number
  vis: number
  geo700: number
  geo850: number
  geo925: number
  rviento: number
  nieve: number

  constructor(serviceObservationAemet: ServiceObservationAemet) {
    this.id = serviceObservationAemet.ID_OBSERVACIONES_AEMET
    this.fint = serviceObservationAemet.FINT
    this.prec = serviceObservationAemet.PREC
    this.pacutp = serviceObservationAemet.PACUTP
    this.pliqtp = serviceObservationAemet.PLIQTP
    this.psolt = serviceObservationAemet.PSOLT
    this.vmax = serviceObservationAemet.VMAX
    this.vv = serviceObservationAemet.VV
    this.vmaxu = serviceObservationAemet.VMAXU
    this.vvu = serviceObservationAemet.VVU
    this.originWindDirection = serviceObservationAemet.DV
    this.dvu = serviceObservationAemet.DVU
    this.dmax = serviceObservationAemet.DMAX
    this.dmaxu = serviceObservationAemet.DMAXU
    this.stdvv = serviceObservationAemet.STDVV
    this.stddv = serviceObservationAemet.STDDV
    this.stdvvu = serviceObservationAemet.STDVVU
    this.stddvu = serviceObservationAemet.STDDVU
    this.hr = serviceObservationAemet.HR
    this.inso = serviceObservationAemet.INSO
    this.pres = serviceObservationAemet.PRES
    this.presNmar = serviceObservationAemet.PRES_NMAR
    this.ts = serviceObservationAemet.TS
    this.tss20cm = serviceObservationAemet.TSS20CM
    this.tss5cm = serviceObservationAemet.TSS5CM
    this.ta = serviceObservationAemet.TA
    this.tpr = serviceObservationAemet.TPR
    this.tamin = serviceObservationAemet.TAMIN
    this.tamax = serviceObservationAemet.TAMAX
    this.vis = serviceObservationAemet.VIS
    this.geo700 = serviceObservationAemet.GEO700
    this.geo850 = serviceObservationAemet.GEO850
    this.geo925 = serviceObservationAemet.GEO925
    this.rviento = serviceObservationAemet.RVIENTO
    this.nieve = serviceObservationAemet.NIEVE
  }

  static fromSynop(synop: Synop) {
    return new ObservationAemet({
      DV: synop.windDirection,
      HR: synop.relativeHumidity,
      PRES: synop.pressure,
      TA: synop.getTemperatureCelsius(),
      VMAX: synop.maximumWindGustSpeed,
      VV: synop.windSpeed
    })
  }

  getDate() {
    const date = this.fint
    return DateService.parseDate(date!, 'YYYY-MM-DDTHH:mm:ss')
  }
}
